function assertNotNullOrUndefined<Type>(value : Type | undefined | null, name : string = "value") : Type
{
    if (value === null || value === undefined) {
        throw new Error(`${name} cannot be null or undefined`);
    }

    return value;
}

function assertNotUndefined<Type>(value : Type | undefined, name : string = "value") : Type
{
    if (value === undefined) {
        throw new Error(`${name} cannot be null or undefined`);
    }

    return value;
}

function assertEquals(value : unknown, other : unknown)
{
    if (value !== other) {
        throw new Error(`${value} is not equal to ${other}`);
    }
}

function assertTrue(value : boolean, name : string = "value")
{
    if (!value) {
        throw new Error(`${name} is not true`);
    }
}

export const Assert = () => {
    return
}

Assert.assertNotNullOrUndefined = assertNotNullOrUndefined;
Assert.assertNotUndefined = assertNotUndefined;
Assert.assertEquals = assertEquals;
Assert.assertTrue = assertTrue;
